<ng-template #PasswordChangeEc>
    <div class="centered-content">
        <div
            style="display: flex; justify-content: center; align-items: center; flex-direction: column; background: #e6e6e6">
            <div
                style="max-width: 736px; width: 100%; height: auto; margin: 0 auto; padding: 20px 44px 40px; background: #fff">
                <div nxLayout="grid maxwidth">
                    <div nxRow>
                        <div nxCol="12" style="text-align: center;">
                            <h3 nxHeadline="subsection-medium" translate>
                                profile.texts.password-change</h3>
                            <p translate>
                                profile.texts.password-change-ec-info
                            </p>
                        </div>
                    </div>
                    <div nxRow>
                        <div nxCol="12">
                            <form [formGroup]="form" class="modal-form-report" (submit)="changePassword($event)">
                                <nx-formfield label="{{ 'profile.texts.password-change-new' | translate }}">
                                    <input required nxInput #password type="password" nxAriaLabel="{{ 'profile.texts.password-change-new' | translate }}"
                                        formControlName="password" />
                                    <nx-password-toggle [control]="password" ariaLabel="Your custom show password label"
                                        nxFormfieldSuffix></nx-password-toggle>
                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form?.errors?.password == 'required'">
                                        {{ 'change-password.required' | translate }}
                                    </nx-error>
                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form?.errors?.repeatedPassword == 'mismatch'">
                                        {{ 'change-password.mismatch' | translate }}
                                    </nx-error>
                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form?.errors?.password == 'bad-input'">
                                        {{ 'change-password-ec.bad-input' | translate }}
                                    </nx-error>
                                </nx-formfield>
                                <nx-formfield label="{{ 'profile.texts.password-change-new-repeat' | translate }}">
                                    <input required nxInput #repeatedPassword type="password" nxAriaLabel="{{ 'profile.texts.password-change-new-repeat' | translate }}"
                                        formControlName="repeatedPassword" />
                                    <nx-password-toggle [control]="repeatedPassword"
                                        ariaLabel="Your custom show password label"
                                        nxFormfieldSuffix></nx-password-toggle>
                                    <nx-error nxFormfieldError appearance="text"
                                        *ngIf="form?.errors?.repeatedPassword == 'mismatch'">
                                        {{ 'change-password.mismatch' | translate }}
                                    </nx-error>
                                </nx-formfield>
                                <div nxRow rowJustify="center">
                                    <button nxButton="primary normal" type="submit">
                                        <span translate>profile.texts.send</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>